<div class="screen-container flex-direction-column">
    <button class="tv-round-icon-button-icon-medium-light-blue button-left-margin-auto" type="button" (click)="toggleSize()">
        <mat-icon matPrefix>
          {{ isMinimized ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
        </mat-icon>
    </button>
    <form [formGroup]="screenForm">
        <div
            class="layout-row"
            *ngIf="data.isCreating || (!data.isCreating && this.selectedView === 1) || (!data.isCreating && this.selectedView === 2)">
            <div class="flex-direction-column center">
                <span class="title">{{ this.screenForm.get('screenHour').value }}</span>
                <span class="subtitle">{{ this.data.screenChannel[0].name }}</span>
            </div>
            <div class="vertical-separator"></div>
            <div class="tv-container-select-white-rect-extensible width-230px">
                <mat-form-field>
                    <mat-label>Etat</mat-label>
                    <mat-select panelClass="tv-custom-always-visible-scroll-bar" formControlName="screenStatus">
                        <mat-option
                            class="tv-ns-select-option"
                            *ngFor="
                                let status of this?.data?.screenSelected?.screenStatusId === screenInIncident ||
                                this?.data?.screenSelected?.screenStatusId === screenInactive ||
                                data.isCreating
                                    ? screenStatusToUse
                                    : screenStatus
                            "
                            [value]="status.codtype">
                            {{ status.libtype }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="chip-custom align-layout">
                <div class="tv-custom-chip-list">
                    <div
                        *ngFor="let view of displayViews"
                        (click)="selectedDisplayView(view)"
                        class="tv-custom-chip-list-item"
                        [ngClass]="{
                            'tv-custom-chip-list-item-selected': this.selectedView === view?.id
                        }">
                        {{ view.display }}
                    </div>
                </div>
            </div>
        </div>

        <div class="update-screen-container flex-direction-row" *ngIf="!data.isCreating && this.selectedView === 0 && !data.screenTransfer">
            <div class="title-div flex-direction-row" *ngIf="this.data.screenSelected.length <= 1">
                <span class="title-one">Modification d'écran </span>
            </div>
        </div>
        <div class="update-screen-container flex-direction-row" *ngIf="data.screenTransfer">
            <div class="title-div flex-direction-row">
                <span class="title-one">Transfert NAT-REG vers 100% NAT </span>
            </div>
        </div>
        <div class="update-screen-container flex-direction-row" *ngIf="!data.isCreating && this.selectedView === 0 && !data.screenTransfer">
            <div *ngIf="this.data.screenSelected.length > 1" class="flex-direction-column center">
                <span *ngIf="this.data.screenSelected.length > 1" class="title">Modification Multiple</span>
                <span class="subtitle">{{ this.data.screenSelected.length }} écran(s)</span>
            </div>
            <div class="ca-div" *ngIf="this.data.screenSelected.length <= 1">
                <div class="flex-direction-row">
                    <span class="ca-label">CA Brut : </span>
                    <span class="ca-info">
                        {{ this.data.screenSelected[0].screenCaBrut ? (this.data.screenSelected[0].screenCaBrut | number : '1.0-0') : '0' }}
                        €
                    </span>
                </div>
                <div class="padding-top flex-direction-row">
                    <span class="ca-label">CA Net : </span>
                    <span class="ca-info">
                        {{ this.data.screenSelected[0].screenCaNet ? (this.data.screenSelected[0].screenCaNet | number : '1.0-0') : '0' }} €
                    </span>
                </div>
            </div>

            <div class="vertical-separator"></div>
            <div class="tv-container-select-white-rect-extensible width-230px">
                <mat-form-field>
                    <mat-label *ngIf="!this.statusIsSame">Mixte</mat-label>
                    <mat-label *ngIf="this.data.screenSelected.length < 2 || this.statusIsSame">Etat</mat-label>
                    <mat-select panelClass="tv-custom-always-visible-scroll-bar" formControlName="screenStatus">
                        <mat-option class="tv-ns-select-option" *ngFor="let status of screenStatus" [value]="status">
                            {{ status.libtype }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="this.data.screenSelected.length <= 1" class="chip-custom align-layout">
                <div class="tv-custom-chip-list">
                    <div
                        *ngFor="let view of displayViews"
                        (click)="selectedDisplayView(view)"
                        class="tv-custom-chip-list-item"
                        [ngClass]="{
                            'tv-custom-chip-list-item-selected': this.selectedView === view?.id
                        }">
                        {{ view.display }}
                    </div>
                </div>
            </div>
        </div>
        <div class="horizontal-separator"></div>
        <div *ngIf="this.selectedView === 0">
            <app-screen-information
                [screenForm]="screenForm"
                [screenPriceLib]="screenPriceLib"
                [screenTypes]="screenTypes"
                [selectedType]="selectedType"
                [screenDurCalMax]="screenDurCalMax"
                [individualTypes]="individualTypes"
                [screenTypeToDelete]="screenTypeToDelete"
                [screenTypeToInsert]="screenTypeToInsert"
                [screenInClosureDate]="screenInClosureDate"
                [data]="data">
            </app-screen-information>
            <div class="screen-action-container">
                <button class="tv-ns-secondary-large-button-on-light-bg abandon-button" (click)="onCancelButtonClick()">Annuler</button>
                <button class="tv-ns-validation-large-button" (click)="submitForm()" [disabled]="!screenForm.valid">
                    <div *ngIf="loading" class="spinner-container">
                        <mat-spinner diameter="15" class="light-spinner"></mat-spinner>
                    </div>
                    Valider
                </button>
            </div>
        </div>
        <div *ngIf="this.selectedView === 1">
            <app-screen-historic [screenHistory]="screenHistory"> </app-screen-historic>
        </div>
        <div *ngIf="this.selectedView === 2">
            <app-screen-spots [spotsList]="spotsList"> </app-screen-spots>
        </div>
    </form>
</div>
